/**
 * Déconnexion automatique après une période sans activité (poste partagé à
 * l'accueil, ordinateur laissé ouvert) : protège les dossiers des patients.
 * L'activité d'un onglet compte pour tous les onglets ouverts.
 */
export const DUREE_MINUTES = 30

const CLE = 'derniere-activite'
let minuterie = null
let dernierEnregistrement = 0

function noter() {
  const t = Date.now()
  if (t - dernierEnregistrement < 15000) return
  dernierEnregistrement = t
  try { localStorage.setItem(CLE, String(t)) } catch (e) { /* rien */ }
}

function derniere() {
  try { return Number(localStorage.getItem(CLE)) || Date.now() } catch (e) { return Date.now() }
}

/** @param {Function} surExpiration appelée une fois quand le délai est dépassé */
export function surveillerInactivite(surExpiration, minutes = DUREE_MINUTES) {
  arreterSurveillance()
  dernierEnregistrement = 0
  noter()
  ;['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'wheel'].forEach(ev => window.addEventListener(ev, noter, { passive: true }))
  minuterie = setInterval(() => {
    if (Date.now() - derniere() > minutes * 60 * 1000) {
      arreterSurveillance()
      surExpiration()
    }
  }, 30000)
}

export function arreterSurveillance() {
  clearInterval(minuterie)
  minuterie = null
  ;['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll', 'wheel'].forEach(ev => window.removeEventListener(ev, noter))
}
